export const DEFAULT_COLORS = [
  'var(--color-green)',
  'var(--color-pastel-green)',
  'var(--color-blue-500)',
  'var(--color-purple)',
  'var(--color-corn)',
  'var(--color-aero)',
  'var(--color-orange)',
  'var(--color-ocean)',
  'var(--color-violet)',
];

export const STATUS_COLORS: { [key: string]: string } = {
  'on-time': 'var(--color-green)',
  early: 'var(--color-pastel-green)',
  late: 'var(--color-orange)',
  delay: 'var(--color-ocean)',
  pending: 'var(--color-powder)',
  processing: 'var(--color-violet)',
  completed: 'var(--color-aero)',
  cancelled: 'var(--color-purple)',
};

export const DEVICE_COLORS: { [key: string]: string } = {
  desktop: 'var(--color-pastel-green)',
  mobile: 'var(--color-green)',
  tablet: 'var(--color-corn)',
  smarttv: 'var(--color-aero)',
  console: 'var(--color-orange)',
  wearable: 'var(--color-purple)',
  embedded: 'var(--color-ocean)',
  unknown: 'var(--color-powder)',
};
